import type { VideoContentObject } from 'models';
import { Card, CollapsibleCard, Icon, RichTextRenderer } from 'ui';
import { Translation } from 'features/translations';

type P = {
  videoContentObject: VideoContentObject;
};

const DescriptionCard = ({ videoContentObject }: P) => (
  <CollapsibleCard card={{ title: <Card.Title icon={<Icon icon="document-line" />}>Description</Card.Title> }}>
    <RichTextRenderer data={videoContentObject.video.htmlContent} />
    <Translation id={videoContentObject.video.id} type="video" />
  </CollapsibleCard>
);

export default DescriptionCard;
